import SelectBox from "../SelectBox";
import { Controller } from "react-hook-form";
import { FormError } from "../../FormError";
import { useEffect, useState } from "react";
import { setSelectBoxValue } from "../../../Utils/utils/CommanFnc";
import { useSelector } from "react-redux";
//import { useEffect } from "react/cjs/react.development";
export function AdditionalPlaceBusiness(props){
    const { errors, 
            zoneName, 
            control, 
            register, 
            itemKey:key, 
            removePlace,
            setValue,
            placeText} = props;
            console.log(errors)
    const [cityList, setCityList] = useState([]);
    const cities = useSelector((state) => state.initialData.CitiesList);
    useEffect( () =>{
        const cityData = cities.map((item) => ({
            value: item.id,
            label: item.name,
          }));
        setCityList(cityData);
        setValue(`businessEntityBranches.other.${key}.state`, zoneName?.value)
        //console.log(new Date().getTime(), '----',item.cityList)
    },[cities, key, setValue, zoneName?.value])
    
    
    return (
        <div key={key} className="card-body pt-0">
            <div className="addAdditionalBusiness">
                <div className="element">{placeText}</div>
                <button
                    onClick={() => removePlace(key)}
                    type="button"
                    className="btn btn-danger">
                    Remove
                </button>
            </div>
            <div  className="card-body pt-0">
            <div className="row">
                        <div className="col-4">
                            <div className="form-group mb-3">
                            <label
                                htmlFor="card-number"
                                className={`d-block input-label ${
                                errors?.businessEntityBranches?.other?.[key]
                                    ?.state?.message && "error"
                                }`}
                            >
                                State
                            </label>
                            <input type={"text"} className="form-control"  value={zoneName?.label?zoneName.label:''} readOnly/>
                            <input type={"hidden"} className="form-control" {...register(`businessEntityBranches.other.${key}.state`)}  readOnly/>
                            
                            {errors?.businessEntityBranches?.other?.[key]
                                ?.state && (
                                <FormError
                                message={
                                    errors?.businessEntityBranches?.other?.[
                                    key
                                    ]?.state.message
                                }
                                />
                            )}
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="form-group mb-3">
                            <label
                                htmlFor="card-number"
                                className={`d-block input-label ${
                                errors?.businessEntityBranches?.other?.[key]
                                    ?.district?.message && "error"
                                }`}>
                                District
                            </label>
                            <Controller
                                control={control}
                                name={`businessEntityBranches.other.${key}.district`}
                                // value={status[0]['value']}
                                defaultValue={''}
                                render={({ field: {value, onChange } }) => (
                                    <SelectBox
                                        isClearable={true}
                                        className={`${
                                        errors?.businessEntityBranches?.other?.[
                                            key
                                        ].district && "error"
                                        }`}
                                        options={cityList}
                                        onChange={(opt) => {   return onChange(opt?.value?opt?.value:'')}}
                                        value={setSelectBoxValue(cityList, value) }
                                    />
                                )}
                            />
                            {errors?.businessEntityBranches?.other?.[key]
                                ?.district && (
                                <FormError
                                message={
                                    errors?.businessEntityBranches?.other?.[
                                    key
                                    ]?.district.message
                                }
                                />
                            )}
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="form-group mb-3">
                            <label
                                htmlFor="card-number"
                                className={`d-block input-label ${
                                errors?.businessEntityBranches?.other?.[key]
                                    ?.pincode?.message && "error"
                                }`}
                            >
                                PIN Code
                            </label>
                            <input
                                type="text"
                                defaultValue=""
                                {...register(
                                `businessEntityBranches.other.${key}.pincode`
                                )}
                                placeholder="PIN Code"
                                className={`form-control ${
                                errors?.businessEntityBranches?.other?.[key]
                                    ?.pincode && "error"
                                }`}
                            />
                            {errors?.businessEntityBranches?.other?.[key]
                                ?.pincode && (
                                <FormError
                                message={
                                    errors?.businessEntityBranches?.other?.[
                                    key
                                    ]?.pincode.message
                                }
                                />
                            )}
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="col-12 p-0">
                            <div className="form-group mb-3">
                                <label
                                htmlFor="card-number"
                                className={`d-block input-label ${
                                    errors?.businessEntityBranches?.other?.[
                                    key
                                    ]?.contactNo?.message && "error"
                                }`}
                                >
                                Contact
                                </label>
                                <input
                                type="text"
                                {...register(
                                    `businessEntityBranches.other.${key}.contactNo`
                                )}
                                className={`form-control ${
                                    errors?.businessEntityBranches?.other?.[
                                    key
                                    ]?.contactNo && "error"
                                }`}
                                placeholder="Contact"
                                />
                                {errors?.businessEntityBranches?.other?.[key]
                                ?.contactNo && (
                                <FormError
                                    message={
                                    errors?.businessEntityBranches?.other?.[
                                        key
                                    ]?.contactNo.message
                                    }
                                />
                                )}
                            </div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="col-12 p-0">
                            <div className="form-group mb-3">
                                <label
                                htmlFor="card-number"
                                className={
                                    errors?.businessEntityBranches?.other?.[
                                    key
                                    ]?.email && (
                                    <FormError
                                        message={
                                        errors?.businessEntityBranches
                                            ?.other?.[key]?.email.message
                                        }
                                    />
                                    )
                                }
                                >
                                Email
                                </label>
                                <input
                                type="text"
                                {...register(
                                    `businessEntityBranches.other.${key}.email`
                                )}
                                placeholder="Email"
                                className={`form-control ${
                                    errors?.businessEntityBranches?.other?.[
                                    key
                                    ]?.email && "error"
                                }`}
                                />
                                {errors?.businessEntityBranches?.other?.[key]
                                ?.email && (
                                <FormError
                                    message={
                                    errors?.businessEntityBranches?.other?.[
                                        key
                                    ]?.email.message
                                    }
                                />
                                )}
                            </div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="form-group mb-3">
                            <label
                                htmlFor="card-number"
                                className={
                                errors?.businessEntityBranches?.other?.[key]
                                    ?.address && (
                                    <FormError
                                    message={
                                        errors?.businessEntityBranches
                                        ?.other?.[key]?.address.message
                                    }
                                    />
                                )
                                }
                            >
                                Address
                            </label>
                            <textarea
                                rows="5"
                                defaultValue=""
                                {...register(
                                `businessEntityBranches.other.${key}.address`
                                )}
                                placeholder="Address"
                                className={`form-control ${
                                errors?.businessEntityBranches?.other?.[key]
                                    ?.address && "error"
                                }`}
                            />
                            {errors?.businessEntityBranches?.other?.[key]
                                ?.address && (
                                <FormError
                                message={
                                    errors?.businessEntityBranches?.other?.[
                                    key
                                    ]?.address.message
                                }
                                />
                            )}
                            </div>
                        </div>
                    </div>
            </div>
        </div>
        
    )

}